import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Tailwind CSS (design system)
import './styles/tailwind.css'

// CSS personalizzati DomusAurea tuttora in uso
import './styles/navigation-components.css'
import './styles/third-party-libraries.css'
import { initializeThemePreference } from './lib/themePreference'

initializeThemePreference()

import App from './App'

// La shell viene installata in cache al primo caricamento riuscito.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch((error: unknown) => {
      console.error('Registrazione service worker non riuscita', error)
    })
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
